export const PREPARE_ACTIONS = {
  PROCEED: 'proceed',
  CANCEL: 'cancel',
  ASSET_COPY: 'assetCopy',
};
